/** Matches the leading `YYYY-MM-DD` of a BQ date or timestamp string. */
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Format a BQ period_start / bucket date for chart axis labels (dd/MM/yy).
 *
 * Read off the string rather than via `new Date(dateStr)`, which parses
 * `YYYY-MM-DD` as UTC midnight while `getDate()` reads local time — rendering
 * every axis label a day early for anyone in a negative UTC offset.
 */
export function formatCompetitorChartDate(dateStr: string): string {
  const match = ISO_DATE.exec(dateStr);
  if (!match) return dateStr;
  const [, yyyy, mm, dd] = match;
  return `${dd}/${mm}/${yyyy.slice(2)}`;
}
